import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontRobotoCondensed, theme } from "shared/lib/styles";

import LogoDarkPlus from "scmp-app/components/plus/plus-widget/logo-dark-plus.svg";
import { PlusWidgetQuotes } from "scmp-app/components/plus/plus-widget/plus-widget-quotes";

export const Container = styled.div`
  display: grid;
  grid:
    "logo-plus" min-content
    "intro" min-content
    "quote" min-content
    "highlights-from-scmp-plus" min-content
    / minmax(0, 1fr);
  ${theme.breakpoints.between("tablet", "desktop")} {
    grid:
      "logo-plus logo-plus" min-content
      "intro highlights-from-scmp-plus" min-content
      "quote highlights-from-scmp-plus" 1fr
      / minmax(0, 1fr) minmax(0, 1fr);

    column-gap: 24px;
  }
`;

export const StyledLogoPlus = styled(LogoDarkPlus)`
  grid-area: logo-plus;

  margin-block-end: 24px;
`;

export const Intro = styled.div`
  grid-area: intro;

  margin-block-end: 24px;
  border-block-end: 1px solid rgba(255, 255, 255, 0.3);

  padding-block-end: 24px;

  ${theme.breakpoints.between("tablet", "desktop")} {
    inline-size: 100%;
    margin-block-end: 0;
    padding-block-end: 24px;
    padding-inline-end: 24px;
    border-block-end: 0;
    border-inline-end: 1px solid rgba(255, 255, 255, 0.3);
  }
`;

export const IntroText = styled.div`
  margin-block-end: 12px;

  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 18.75px;
  ${theme.breakpoints.between("tablet", "desktop")} {
    margin-block-end: 24px;
  }
  span {
    color: #8ab2ff;
    font-weight: 700;
  }
`;

export const TryForFreeButtonLink = styled(BaseLink)`
  inline-size: 100%;
  padding-block: 8px;

  color: #ffffff;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 130%;
  text-align: center;

  border-radius: 2px;

  background: #4585ff;

  &:hover {
    text-decoration: underline;
  }
`;

export const StyledPlusWidgetQuotes = styled(PlusWidgetQuotes)`
  grid-area: quote;
`;

export const Title = styled.div`
  margin-block-end: 20px;

  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  text-transform: uppercase;
`;

export const HighlightsFromScmpPlus = styled.div`
  grid-area: highlights-from-scmp-plus;
`;

export const DailyPulse = styled.div`
  grid-area: daily-pulse;

  margin-block-end: 16px;
  padding-block-end: 16px;
  border-block-end: 1px solid rgba(255, 255, 255, 0.3);

  ${theme.breakpoints.between("tablet", "desktop")} {
    margin-block-end: 0;
    padding-block-end: 0;
    border-inline-end: 1px solid rgba(255, 255, 255, 0.3);
    border-block-end: 0;
  }
`;

export const NewsAgenda = styled.div`
  grid-area: news-agenda;

  margin-block-end: 16px;
  padding-block-end: 16px;
  border-block-end: 1px solid rgba(255, 255, 255, 0.3);

  ${theme.breakpoints.between("tablet", "desktop")} {
    margin-block-end: 0;
    padding-block: 20px 0;
    padding-inline-end: 24px;
    border-block-end: 0;
    border-inline-end: 1px solid rgba(255, 255, 255, 0.3);
  }
`;
